<!-- For each section; add a collapse, flex columns -->

<!-- DISPLAY MODE -->
<div *ngIf="!editMode"
     class="crud-display-collapse-container">

  <!-- WITH COLLAPSIBLE SECTIONS -->
  <ng-container *ngIf="config?.showInCollapsedSections === true">
    <nz-collapse [nzBordered]="true"
                 [nzExpandIconPosition]="'right'"
                 class="crud-fields-display-collapse">
      <nz-collapse-panel *ngFor="let itemSection of itemSections; let i = index"
                         [attr.data-section-index]="i"
                         [attr.data-section-key]="itemSection?.key"
                         [ngClass]="getCollapsePanelClasses(itemSection)"
                         [nzActive]="collapsePanelsActive"
                         [nzExtra]="collapseExtra"
                         [nzHeader]="itemSection?.titleType ? getTitleWithHeadingType(itemSection?.titleType, itemSection?.title || '') : (itemSection?.title || '')"
                         (nzActiveChange)="onCollapseActiveChange($event, itemSection)">
        <ng-container *ngTemplateOutlet="section; context: {$implicit: itemSection}"></ng-container>
      </nz-collapse-panel>
    </nz-collapse>
  </ng-container>

  <!-- WITHOUT SECTIONS -->
  <ng-container *ngIf="!config?.showInCollapsedSections">
    <div *ngFor="let itemSection of itemSections">
      <ng-container *ngTemplateOutlet="section; context: {$implicit: itemSection}"></ng-container>
    </div>
  </ng-container>

</div>




<div *ngIf="editMode">
  <rappider-crud-view-edit-form [config]="config"
                                [data]="data"
                                (fieldValueChange)="onFieldValueChange($event)"
                                (formSubmit)="onFormSubmit($event)"
                                (cancelButtonClick)="onFormCancel()"></rappider-crud-view-edit-form>

</div>

<!-- for each item in the section add a field displayer -->


<ng-template #noValue>
  <div class="no-value">
    <nz-skeleton [nzActive]="true"
                 [nzParagraph]="false"></nz-skeleton>
  </div>
</ng-template>


<!-- SECTION CONTENT -->
<ng-template #section
             let-itemSection>
  <div class="section-container">
    <div *ngFor="let item of groupedItems[itemSection.key]"
         class="item-area"
         [style.width]="getItemSize(itemSection)">

      <!-- TITLE -->
      <div class="property-title"
           [ngClass]="getFieldLabelClasses(item)"
           [style.color]="getTextColorValue(item?.textColor)"
           [style.background-color]="getBackgroundColorValue(item)"
           [style.font-weight]="item?.textStyle === TextStyleType.Bold || item?.textStyle === TextStyleType.BoldItalic ? 'bold' : ''"
           [style.font-style]="item?.textStyle === TextStyleType.Italic || item?.textStyle === TextStyleType.BoldItalic ? 'italic' : ''"
           [style.text-decoration]="item?.textStyle === TextStyleType.Underline ? 'underline' : ''">
        <span>{{ item.title | translate }}</span>
        <i *ngIf="item.fieldDescription"
           class="fa fa-info-circle"
           [nzTooltipTitle]="item.fieldDescription | translate"
           nzTooltipPlacement="right"
           nz-tooltip></i>
      </div>
      <!-- END OF TITLE -->

      <!-- VALUE -->
      <div *ngIf="data && item?.fieldName else noValue"
           class="property-value">
        <ng-container *ngIf="item?.type === CrudViewFormItemType.Table">
          <rappider-table [config]="item?.settings"
                          [data]="data[item?.fieldName]"></rappider-table>
        </ng-container>
        <ng-container *ngIf="item?.type === CrudViewFormItemType.CheckBox">
          <i *ngIf="!!data[item.fieldName]"
             class="fa-light fa-square-check"></i>
          <i *ngIf="!data[item?.fieldName]"
             class="fa-light fa-square"></i>
        </ng-container>
        <ng-container *ngIf="item?.type === CrudViewFormItemType.MarkDown">
          <rappider-markdown-viewer [markdownText]="data[item?.fieldName]"
                                    [typeInRealTime]="item?.typeInRealTime"></rappider-markdown-viewer>
        </ng-container>
        <ng-container *ngIf="!itemsDoNotShowAsLabel?.includes(item?.type)">
          <!-- If there is a displayFormatFunction; use it to format the value -->
          <ng-container *ngIf="item?.displayFormatFunction">
            <rappider-text [text]="item?.displayFormatFunction(data[item?.fieldName])"
                          [colorSettings]="getValueColorSettings(item?.valueTextColor, item)"
                          [typography]="getValueTypographySettings(item?.valueTextStyle)"></rappider-text>
          </ng-container>
          <!-- If there is NO displayFormatFunction; display the value as it is -->
          <ng-container *ngIf="!item?.displayFormatFunction">
            <ng-container *ngIf="isObject(data[item?.fieldName]); else defaultRappiderText">
              <rappider-json-viewer [data]="data[item?.fieldName]"
                                    [maxLineToDisplay]="50"></rappider-json-viewer>
            </ng-container>
            <ng-template #defaultRappiderText>
              <rappider-text [text]="data[item?.fieldName]"
                            [colorSettings]="getValueColorSettings(item?.valueTextColor, item)"
                            [typography]="getValueTypographySettings(item?.valueTextStyle)"></rappider-text>
            </ng-template>
          </ng-container>
        </ng-container>
      </div>
      <!-- END OF VALUE -->

    </div>
  </div>
</ng-template>
